export default {"src":"/_next/static/media/logo-dark-mode.a1e7be63.svg","height":26,"width":211};